<template>
    <div class="results-box">
        <h1>Effectiveness</h1>
        <medal :medalType="label" />
        <p v-html="desc"></p>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex"
    import Medal from '@/components/Medal.vue'
    
    export default{
        name : "EffectivenessRibbonFeedback",
        components: {
            'medal' : Medal,
        },
        data(){
            return {
                rbn : "",
                desc : "",
                label: ""
            }
        },
        mounted(){
            this.setRibbon()
        },
        computed : {
            ...mapGetters([
                "getScoring",
                "getEffectivenessResult"
            ])
        },
        methods : {
            setRibbon(){
                const effectiveness = this.getScoring.effectiveness.options
                const cat = this.getEffectivenessResult

                this.rbn = effectiveness[ cat ].source
                this.desc = effectiveness[ cat ].description
                this.label = cat;
            }
        }
    }
</script>